import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgErrorOutline = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	xmlnsXlink: "http://www.w3.org/1999/xlink",
	preserveAspectRatio: "xMidYMid meet",
	viewBox: "0 0 14 14",
	width: 14,
	height: 14,
	...props,
	children: [/* @__PURE__ */ _jsxs("defs", { children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M13 7C13 10.31 10.31 13 7 13C3.69 13 1 10.31 1 7C1 3.69 3.69 1 7 1C10.31 1 13 3.69 13 7Z",
			id: "a2pB5I7Sno"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M6.25 2.98L7.75 2.98L7.75 8.36L6.25 8.36L6.25 2.98Z",
			id: "c1jyIZiA9O"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M6.25 9.08L7.75 9.08L7.75 10.58L6.25 10.58L6.25 9.08Z",
			id: "b3WQjyAmI4"
		})
	] }), /* @__PURE__ */ _jsx("g", { children: /* @__PURE__ */ _jsxs("g", { children: [
		/* @__PURE__ */ _jsxs("g", { children: [/* @__PURE__ */ _jsx("use", {
			xlinkHref: "#a2pB5I7Sno",
			opacity: 1,
			fill: "#ffffff",
			fillOpacity: 0
		}), /* @__PURE__ */ _jsx("g", { children: /* @__PURE__ */ _jsx("use", {
			xlinkHref: "#a2pB5I7Sno",
			opacity: 1,
			fillOpacity: 0,
			stroke: "#ff3c2a",
			strokeWidth: 1.5,
			strokeOpacity: 1
		}) })] }),
		/* @__PURE__ */ _jsx("g", { children: /* @__PURE__ */ _jsx("use", {
			xlinkHref: "#c1jyIZiA9O",
			opacity: 1,
			fill: "#ff3c2a",
			fillOpacity: 1
		}) }),
		/* @__PURE__ */ _jsx("g", { children: /* @__PURE__ */ _jsx("use", {
			xlinkHref: "#b3WQjyAmI4",
			opacity: 1,
			fill: "#ff3c2a",
			fillOpacity: 1
		}) })
	] }) })]
});
export default SvgErrorOutline;
